/* eslint-disable */

import { BsCodeSlash } from "react-icons/bs";
import { Android } from "@material-ui/icons";
import { BiBriefcase } from "react-icons/bi";
import { AiOutlineAntDesign } from "react-icons/ai";
import { GiPaintBrush } from "react-icons/gi";
import { IoLogoModelS } from "react-icons/io";
import { FaRobot, FaCloud, FaCogs } from "react-icons/fa";

export const servicesData = [
  {
    id: 1,
    title: "AI Solutions",
    icon: <FaRobot />,
  },
  {
    id: 2,
    title: "Web Development",
    icon: <BsCodeSlash />,
  },
  {
    id: 3,
    title: "Mobile App Development",
    icon: <Android />,
  },
  {
    id: 4,
    title: "SaaS Development",
    icon: <IoLogoModelS />,
  },
  {
    id: 5,
    title: "Cloud Solutions",
    icon: <FaCloud />,
  },
  {
    id: 6,
    title: "Business Automation",
    icon: <FaCogs />,
  },
  {
    id: 7,
    title: "UI/UX Design",
    icon: <GiPaintBrush />,
  },
  {
    id: 8,
    title: "Logo & Brand Identity",
    icon: <AiOutlineAntDesign />,
  },
  {
    id: 9,
    title: "Portfolio Websites",
    icon: <BiBriefcase />,
  },
];




// /* eslint-disable */
// import { BiShoppingBag, BiPencil } from "react-icons/bi";
// import { BsCodeSlash, BsClipboardData } from "react-icons/bs";
// import { AiOutlineMail, AiFillAudio } from "react-icons/ai";
// import { Android } from "@material-ui/icons";
// import { IoLogoModelS } from "react-icons/io";
// import { FaInternetExplorer,  FaChalkboardTeacher, FaCameraRetro, FaPinterest, FaVideo, FaTabletAlt, FaRegNewspaper } from "react-icons/fa";
// import { IoLogoDesignernews } from "react-icons/io5";
// import { GiPaintBrush } from 'react-icons/gi';
// import { AiOutlineAntDesign } from 'react-icons/ai';
// import { FaBullhorn } from 'react-icons/fa';
// import { BiBriefcase } from 'react-icons/bi'; // Portfolio Icon
 

// export const servicesData = [
//     {
//         id: 6,
//         title: 'Web Design And Developnment',
//         icon: <BsCodeSlash />
//     },
//     {
//         id: 1,
//         title: 'Mobile App Developnment',
//         icon: <Android/>
//     },
    
//     {
//         id: 17,
//         title: 'Portfolio Design',
//         icon: <BiBriefcase />
//     },
//     {
//         id: 14,
//         title: 'Graphic Designing',
//         icon: <GiPaintBrush />
//     },
//     {
//         id: 15,
//         title: 'Logo Design',
//         icon: <AiOutlineAntDesign />
//     },
//     {
//         id: 16,
//         title: 'Digital Marketing',
//         icon: <FaBullhorn />
//     },
//     // {
//     //     id: 2,
//     //     title: 'Content Writing',
//     //     icon: <BiPencil /> 
//     // },
//     {
//         id: 3,
//         title: 'Email Marketing',
//         icon: <AiOutlineMail />
//     },
//     {
//         id: 4,
//         title: 'Internet Research',
//         icon: <FaInternetExplorer />
//     },
//     // {
//     //     id: 5,
//     //     title: 'Tutoring',
//     //     icon: <FaChalkboardTeacher />
//     // },

  
//     // {
//     //     id: 7,
//     //     title: 'Photography',
//     //     icon: <FaCameraRetro />
//     // },
//     // {
//     //     id: 8,
//     //     title: 'Pinterest Virtual Assistant',
//     //     icon: <FaPinterest />
//     // }, 
//     {
//         id: 9,
//         title: 'Video Editing',
//         icon: <FaVideo />
//     },
//     // {
//     //     id: 10,
//     //     title: 'Data Entry', 
//     //     icon: <BsClipboardData />
//     // },
//     // {
//     //     id: 11,
//     //     title: 'Ebook Writing',
//     //     icon: <FaTabletAlt />
//     // },
//     // {
//     //     id: 12,
//     //     title: 'Audio Transcription',
//     //     icon: <AiFillAudio />
//     // },
//     {
//         id: 13,
//         title: 'Blog Posting',
//         icon: <FaRegNewspaper />
//     },

// ]

// Uncomment your required service.
// Couldn't find the required services? Raise an issue on github at https://github.com/hhhrrrttt222111/developer-portfolio/issues/new
// You can also add on your own 😉.